module.exports = __webpack_public_path__ + "static/media/Premium-Plans.d0bc4091.png";